export const ENDPOINT_SUGGEST = '/_cars/suggest';
export const FORM_NAME = 'carsSearchForm';
export const SORT__PRICE__LOW_TO_HIGH = 'SORT__PRICE__LOW_TO_HIGH';
export const UNRECOGNISED_SERVER_ERROR = 'UNRECOGNISED_SERVER_ERROR';
export const AGE_DEFAULT = '30';
export const AGE_YOUNGSTER = '23';
export const AGE_OLD = '61';
export const TIME_VALUE_DEFAULT = '12:00';
export const SCROLL_TIME_DEFAULT = 300;
export const SHIFT_DELAY_DEFAULT = 100;
export const REQUEST_DELAY_DEFAULT = 300;
export const SUGGEST_ITEM_NAME_POINTER = 'name';
export const AGE_FIELD_NAME = 'age';
export const PICKUP_FIELD_NAME = 'pickUp';
export const DROPOFF_FIELD_NAME = 'dropOff';

export const PICKUP_PLACE = 'pickUpPlace';
export const PICKUP_DATE = 'pickUpDate';
export const PICKUP_TIME = 'pickUpTime';
export const DROPOFF_PLACE = 'dropOffPlace';
export const DROPOFF_DATE = 'dropOffDate';
export const DROPOFF_TIME = 'dropOffTime';

export const OTT_CARS_PREFIX = 'OTT/cars/';
export const LAST_SEARCH_KEY = `${OTT_CARS_PREFIX}last_search`;

export const VALIDATE_MESSAGES = {
  pickUp: 'Выберите место получения из списка',
  dropOff: 'Выберите место возврата из списка',
  pickUpDate: 'Укажите, когда хотите получить авто',
  dropOffDate: 'Укажите, когда хотите вернуть авто',
  pickUpTime: 'Укажите время получения авто',
  dropOffTime: 'Укажите время возврата авто',
};
